import Event from '../../core/Event';
import { FilterToRemove } from '../../core/arrayOperations';

export default class OrdersFilterRemoved extends Event {
    public static type = 'OrdersFilterRemoved';

    constructor(public readonly filter: FilterToRemove) {
        super(OrdersFilterRemoved.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrdersFilterRemoved.ts